/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { metricdetailConstants } from '../../../constants/okrPopUp.constants';
import * as OkrPopIpActions from '../../../actions/okr_popup.action';
import { isReadOnlyUserLicenseType } from '../../../../utils/common';
import { KrUpdateModalManager, useUpdateModalActions } from '@workboard/ui-okr';

// TODO add more maps
const UpdateKrButton = ({ metric }) => {
    const { t } = useTranslation();
    const { open } = useUpdateModalActions();
    const handleOpen = () => {
        open({
            krId: metric.id,
            source: metric.source
        })
    }

    return (<span
        role="button"
        tabIndex={0}
        className="kr-buttons update-metric-link"
        onClick={handleOpen}
        metric-id={metric.id}
        onKeyPress={(e) => {
            e.preventDefault();
            if (e.key === 'Enter' || e.key === ' ') return handleOpen();
            return true;
        }}
    >
        <span className="icon icon-outline-update-14px-blue" />
            <span className="addmetric-data-link" data-testid="updatekr">
                {t('Update')}
            </span>
    </span>);
}

const GraphFooter = (props) => {
    const { metric, goal, currentUserFullName, onKrUpdated } = props;
    const { t } = useTranslation();
    const openOkrDeatilsPage = (metricId) => {
        // props.dispatch(OkrPopIpActions.UpdateModal(false));
        let reftext = 'goalDetailsPopup';
        const url = `${wbConfig.baseUrl}/goal/krDetails?id=${metricId}&ref=${reftext}`
        window.open(url);
    }
    const [pingPermission, setPingPermission] = useState(false);
    const [sourceName, setSourceName] = useState(null);
    // let [goalFromGoalList, setGoalFromGoalList] = useState([]);
    const [renderGraph, setGraphRender] = useState(null);
    const [selectedUser, setSelectedUser] = useState({});
    function updateConfidenceCallback (data) {
        // Updating the store only when there is change in confidence or comment
        if ((metric.confidence.confidence != data.confidence) || (metric.confidence.comment != data.comment)) {
            props.dispatch(OkrPopIpActions.updateConfidence(data));
        }
    }
    function openKrupdatePop () {
        openEditMetricData(metric.id, '', '', '', '', '', updateConfidenceCallback);
    }

    useEffect(() => {
        const isKrClosed = Number(metric.status) === metricdetailConstants.METRIC_CLOSED;
        const permission = (goal.status == metricdetailConstants.GOAL_ACTIVE) && !isKrClosed;
        let metricSource = metric.source;
        if (metric.mirrorSource) {
            metricSource = metric.mirrorSource;
        }

        if (metric.show_real_owner) {
            if (permission && metric.source == metricdetailConstants.SOURCE_SURVEY) {
                const surveryUserList = metric.source_from_survey;
                if (Array.isArray(surveryUserList)) {
                    const currentUserKey = surveryUserList.indexOf(parseInt(metric.loginuserId));
                    if (currentUserKey > -1) {
                        surveryUserList.splice(currentUserKey, 1)
                    }
                    if (surveryUserList.length > 0) {
                        setPingPermission(permission && true);
                    } else {
                        setPingPermission(permission && false);
                    }
                }
            } else if (permission && (metric.source == metricdetailConstants.SOURCE_DATA_STREAMS
                || metric.source == metricdetailConstants.SOURCE_MIRROR_KR)) {
                setPingPermission(metric.real_owner != metric.loginuserId);
            } else if (permission && metric.source == metricdetailConstants.SOURCE_MIT_PERSON) {
                setPingPermission(metric.real_owner != metric.loginuserId);
                setSourceName(metric.pingOwnerName)
            } else if (permission && metric.source == metricdetailConstants.SOURCE_PERSON) {
                setPingPermission(metric.pingOwnerid != metric.loginuserId);
            } else {
                setPingPermission(
                    permission && metric.real_owner != metric.loginuserId && metric.owner != metric.loginuserId
                )
            }
            if (permission) {
                setSourceName(metric.pingOwnerName)
            }
        } else if (permission && metric.source == metricdetailConstants.SOURCE_PERSON) {
            setPingPermission(metric.owner != metric.loginuserId)
            setSourceName(metric.source_from)
        } else if (permission && metric.source == metricdetailConstants.SOURCE_SURVEY) {
            const surveryUserList = metric.source_from_survey;
            if (Array.isArray(surveryUserList)) {
                const currentUserKey = surveryUserList.indexOf(parseInt(metric.loginuserId));
                if (currentUserKey > -1) {
                    surveryUserList.splice(currentUserKey, 1)
                }
                if (surveryUserList.length > 0) {
                    setPingPermission(permission && true);
                } else {
                    setPingPermission(permission && false);
                }
            }
            const sourceNames = metric.source_from.replace(/(<([^>]+)>)/ig, '')
            const user = `${currentUserFullName}, `;
            setSourceName(sourceNames.replace(user));
        }
    // eslint-disable-next-line
    }, [props]);

    const opneSourceData = (e) => {
        const params:any = {};
        params.id = e.target.getAttribute('data-goal-id');
        params.metricId = e.target.getAttribute('data-metric-id');
        const cascadeMetId = e.target.getAttribute('data-cascade-id');
        const mitMetId = e.target.getAttribute('data-mit-child-id');
        if (typeof e.target.getAttribute('data-cascade-tree') !== 'undefined') {
            params.cascadeTree = 1;
        }
        if (metric.source == metricdetailConstants.SOURCE_SURVEY) {
            const userId = e.target.getAttribute('data-user-id');
            setGraphRender(userId);
            setSelectedUser({
                name: e.target.innerText,
                user_id: userId
            });
        } else if (cascadeMetId !== null || mitMetId !== null) {
            viewCascadeMetric(params.metricId);
        } else if (metric.goal_id && metric.goal_id == params.id) {
            props.dispatch(OkrPopIpActions.UpdateSelectedMetric({ metricId: params.metricId }));
        } else {
            viewGoalDetailsPage(undefined, params);
        }
    }
    const openSourceKR = (e: any) => {
        const eleClass: string = e.target.getAttribute('class');
        if (eleClass == null || eleClass === undefined) {
            return;
        }
        const eleClassArray = eleClass.split(' ');
        if (!(eleClassArray.includes('surveySource') || eleClassArray.includes('metricSource'))) {
            return;
        }
        const targetClosestElement = e.target.closest('.kr-source-text');
        if (targetClosestElement == null) {
            return;
        }
        opneSourceData(e);
    }
    useEffect(() => {
        const body = document.querySelector('body');
        if (body) {
            body.addEventListener('click', openSourceKR);
        }
        return () => {
            if (body) {
                body.removeEventListener('click', openSourceKR);
            }
        }
    }, [metric.id]);

    useEffect(() => {
        if (renderGraph !== null) {
            const chartDataSub = metric.chart_data_sub[renderGraph];
            if (typeof chartDataSub !== 'undefined') {
                props.updateMetricAsSubGraph(chartDataSub, selectedUser);
                setGraphRender(null);
            }
        }
    }, [renderGraph])
    let extraText = '';
    if (metric.source == 3) {
        extraText = metric.progressResultsAs;
    }
    const sourceVal = (typeof metric.mirrorSource !== 'undefined' && metric.mirrorSource)
        ? metric.mirrorSource
        : metric.source;
    const showUpdateHistory = [
        metricdetailConstants.SOURCE_PERSON,
        metricdetailConstants.SOURCE_DATA_STREAMS,
        metricdetailConstants.SOURCE_METRICS,
        metricdetailConstants.SOURCE_OTHER_GOALS,
        metricdetailConstants.SOURCE_SURVEY,
        metricdetailConstants.SOURCE_MIT_PERSON,
        metricdetailConstants.SOURCE_MIT_PERSON_DISTINCT
    ];

    const  isReadOnlyEnabled = isReadOnlyUserLicenseType();
    
    // @ts-ignore
    const uploadFile = (file) => window.FUS.uploadFile(file)

    return (
        <div className="goal-chart-footer" data-testid="goal-chart-footer">
            <div className="left sourced-metric-wrapper" style={{ width: '490px' }}>
                { showUpdateHistory.includes(parseInt(sourceVal))
                    ? (
                        <div className="key-result-details">
                            <a
                                href="javascript:;"
                                className="resultDetails clickable"
                                ref-src="OKR_DETAILS"
                                data-metric-id={metric.id}
                                style={{ color: '#2c9ab7', fontSize: '12px', display: 'inline-block' }}
                            >{t('View update history')}
                            </a>
                        </div>
                    )
                    : <></>}
                {metric.show_real_owner ? (
                    <>
                        <div className="kr-source" data-testid="kr-source">
                            <div className="kr-source-label " role="heading" aria-level={2}>{metric.source_label}</div>
                            <div className="kr-source-text">&nbsp; {metric.source_real_owner} </div>
                        </div>
                        {metric.source_second_label != ''
                            ? (
                                <div className="kr-source">
                                    <div className="kr-source-label " role="heading" aria-level={2}>
                                        {metric.source_second_label}&nbsp;
                                    </div>
                                    <div
                                        className="kr-source-text"
                                        dangerouslySetInnerHTML={
                                            {
                                                __html: metric.progress_string
                                                    ? `${extraText}
                                                        <div>${metric.progress_string}</div>
                                                        ${metric.source_from}
                                                    `
                                                    : `${extraText} ${metric.source_from}`
                                            }
                                        }
                                    />
                                </div>
                            )
                            : <></>}
                    </>
                ) : (
                    <div className="kr-source">
                        <div className="kr-source-label " role="heading" aria-level={2}>{t('Source')}:</div>
                        <div
                            className="kr-source-text"
                            dangerouslySetInnerHTML={
                                {
                                    __html: metric.progress_string
                                        ? `${extraText} <div>${metric.progress_string}</div> ${metric.source_from}`
                                        : `${extraText} ${metric.source_from}`
                                }
                            }
                        />
                    </div>
                )}
            </div>
            <div className="right">
                <a
                    href="javascript:;"
                    className="kr-buttons view-results-details-button"
                    metric-id={metric.id}
                    goal-id={goal.id}
                    onClick={(e) => openOkrDeatilsPage(metric.id)}
                >
                    {t('View results details')}
                </a>
                {(metric.canUpdate && goal.status == metricdetailConstants.GOAL_ACTIVE && !isReadOnlyEnabled)
                    ? (
                        <KrUpdateModalManager mixpanelLocation='GOAL_DETAILS_POPUP' mixpanelLocationDetail='GOAL_DETAILS_POPUP' uploadFile={uploadFile} onUpdate={(response) => {
                            onKrUpdated?.();
                            if (response) {
                                updateConfidenceCallback(response?.metric);
                            }
                        }}>
                            <UpdateKrButton metric={metric} />
                        </KrUpdateModalManager>
                    )
                    : <></>}
                {pingPermission && !isReadOnlyEnabled
                    ? (
                        <button
                            type="button"
                            className="kr-buttons ping-metric-status ping-metric-data-link"
                            metric-owner={metric.show_real_owner ? metric.pingOwnerid : metric.owner}
                            metric-owner_name={sourceName}
                            metric-id={metric.id}
                            style={{ border: '0' }}
                        >
                            <span className="icon icon-outline-notifications-18px-blue" />
                            <span>
                                {t('Ping')}
                            </span>
                        </button>
                    )
                    : <> </>}
                {metric.type && metric.type == metricdetailConstants.TYPE_CASCADE
                    ? (
                        <a
                            href="javascript:;"
                            className="kr-buttons view-cascade-tree clickable"
                            style={{ color: '#2c9ab7' }}
                            data-metric-id={metric.id}
                        >{t('View network')}
                        </a>
                    )
                    : <> </>}
                {
                    metric.source != metricdetailConstants.SOURCE_MIRROR_KR
                    && metric.type == metricdetailConstants.TYPE_CASCADE
                    && typeof metric.feeds != 'undefined'
                    && (
                        <div className="sourced-metric-wrapper" style={{ marginLeft: 16 }}>
                            <span style={{ color: '#666' }}>Feeds: </span>
                            {metric.feeds}
                        </div>
                    )
                }
            </div>
            <div className="clear" />
        </div>
    );
}

export default GraphFooter;
